import { render, staticRenderFns } from "./configPage.vue?vue&type=template&id=af29db26"
import script from "./configPage.vue?vue&type=script&lang=js"
export * from "./configPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports